import type { Dispatch, SetStateAction } from 'react';
import type { CampaignEditorSection } from '../campaign-editor-types';

export const getFooterSecondaryAction = ([activeSection, setActiveSection]: [
  CampaignEditorSection,
  Dispatch<SetStateAction<CampaignEditorSection>>,
]) => {
  const footerSecondaryAction =
    activeSection === 'creators'
      ? {
          label: 'Add post URL',
          onClick: () => setActiveSection('post-urls'),
        }
      : activeSection === 'post-urls'
        ? {
            label: 'Add creators',
            onClick: () => setActiveSection('creators'),
          }
        : undefined;
  return footerSecondaryAction;
};
